/**
 * Gallery stub for ISO subdivision names — avoids the `iso-3166-2` dep.
 * Covers the US states used by the cash-deposit merchant picker mock.
 */

export interface StateOption {
  code: string;
  fullCode: string;
  name: string;
  type: string;
}

const US_STATES: Record<string, string> = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const statesForCountry = (
  countryAlpha2: string | undefined | null,
): StateOption[] => {
  if (!countryAlpha2 || countryAlpha2.toUpperCase() !== 'US') return [];
  return Object.entries(US_STATES)
    .map(([code, name]) => ({
      code,
      fullCode: `US-${code}`,
      name,
      type: 'state',
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

export const stateName = (
  countryAlpha2: string | undefined | null,
  stateCode: string | undefined | null,
): string => {
  if (!stateCode) return '';
  const list = statesForCountry(countryAlpha2);
  const match = list.find(
    (s) => s.code.toUpperCase() === stateCode.toUpperCase(),
  );
  return match?.name ?? stateCode;
};
